import { Sede } from '../models/Entities/Turnero';
import { buildURL } from './commons/CommonService.Functions';
import { officesApiRequest as apiRequest } from './commons/OfficesApi.Functions';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'offices/Sedes';

export const GetSedes = async (token: string): Promise<Sede[]> => {
    return apiRequest<Sede[]>(BaseURL, token, 'GetSedes');
};

export const CreateSede = async (token: string, payload: Sede): Promise<Sede> => {
    return apiRequest<Sede>(BaseURL, token, 'CreateSede', {
        method: 'POST',
        body: JSON.stringify(payload)
    });
};

export const UpdateSede = async (token: string, id: number, payload: Sede): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'UpdateSede', {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
};

export const DeleteSede = async (token: string, id: number): Promise<string> => {
    const requestURL = buildURL(BaseURL, id);
    return apiRequest<string>(requestURL, token, 'DeleteSede', {
        method: 'DELETE'
    });
};
